import React from 'react';
import PropTypes from 'prop-types';
import CheckboxBase from './CheckboxBase';
import { red } from '@mui/material/colors';

class Checkbox extends React.Component {
  static propTypes = {
    /** Pre-defined custom styles to override RadioBase */
    styleType: PropTypes.string,
    /** Classname to be applied to <Radio> */
    className: PropTypes.string,
    /** Value of `input` element */
    value: PropTypes.string,
    /** Text used for input label */
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.element]),
    /** If `true`, the label is displayed as required. */
    required: PropTypes.any,
    /** Callback fired when value is changed */
    onChange: PropTypes.func,
  };

  static defaultProps = {
    styleType: 'default',
  };

  getStyles = type => {
    switch (type) {
      case 'error':
        return {
          root: {
            color: red[400],
          },
        };
      default:
        return {
          labelAsterisk: {
            color: 'red',
          },
        };
    }
  };

  render() {
    const { styleType, options = [], ...otherProps } = this.props;
    const styles = this.getStyles(styleType);

    return <CheckboxBase styles={styles} options={options} {...otherProps} />;
  }
}

export default Checkbox;
